// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0a54b26f","455":"8fd43e89","977":"ddf2ae2a"}[chunkId] + ".chunk.js";
};